module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28081",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4420",
      "atom": "static-1.4783",
      "conversations-async-data": "static-2.7373",
      "conversations-error-reporting": "static-1.8588",
      "conversations-internal-pub-sub": "static-1.15674",
      "conversations-internal-schema": "static-1.12340",
      "conversations-message-history": "static-1.11774",
      "conversations-test-sdk": "static-1.10209",
      "conversations-visitor-experience-components": "static-1.21444",
      "head-dlb": "static-1.4754",
      "hs-promise-utils": "static-1.5302",
      "hs-test-utils": "static-1.7694",
      "hubspot-dlb": "static-2.1786",
      "HubStyleTokens": "static-2.11135",
      "I18n": "static-7.1545",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2729",
      "jasmine-runner": "static-1.6166",
      "quartz": "static-1.6595",
      "react-dlb": "static-1.70",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.59",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4186",
      "StyleGuideUI": "static-3.482",
      "transmute": "static-2.85",
      "urlinator": "static-1.4246",
      "usage-tracker": "static-1.7047",
      "usage-tracker-core": "static-1.6897",
      "usage-tracker-public": "static-1.6858",
      "viral-links-lib": "static-1.6731",
      "visitor-ui-component-library": "static-1.5839",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4497",
      "conversations-prop-types": "static-1.7162",
      "conversations-visitor-message-history": "static-1.20181",
      "cssUtils": "static-1.704",
      "enviro": "static-4.387",
      "flux-actions": "static-1.298",
      "foundations-components": "static-1.7336",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5872",
      "hubspot-url-utils": "static-1.3873",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9346",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.349",
      "raven": "static-3.5624",
      "react": "static-7.176",
      "react-aria": "static-1.60",
      "react-dom": "static-7.85",
      "react-redux": "static-7.66",
      "react-rhumb": "static-1.16344",
      "react-utils": "static-2.5095",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7851",
      "signup-constants": "static-1.18226",
      "styled-components": "static-2.84",
      "usage-tracker-multi": "static-1.5461",
      "visitor-ui-component-library-icons": "static-1.5650",
      "hs-promise-rejection-tracking": "static-1.5291",
      "raven-hubspot": "static-1.5931",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3148",
      "moment": "static-3.26",
      "quartz-config": "static-1.373",
      "quartz-core": "static-1.5814",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4543",
      "foundations-theming": "static-1.4115",
      "UIComponents": "static-3.8082",
      "customer-data-email": "static-1.17526",
      "cv-backend-services": "static-1.1466",
      "immutable-less": "static-1.4366",
      "conversations-skeleton-state": "static-1.6962",
      "crm-events-viz-core": "static-1.32159",
      "customer-agent-discovery-components-lib": "static-1.2222",
      "customer-data-objects": "static-1.7324",
      "data-fetching-client": "static-1.9387",
      "icons": "static-2.614",
      "react-input-autosize": "static-2.17",
      "react-router-dom": "static-5.26",
      "rpc-client-utils": "static-1.4318",
      "ui-images": "static-2.1065",
      "HeadJS": "static-2.693",
      "framer-motion": "static-1.66",
      "hs-test-utils-bend-plugin": "static-1.2805",
      "msw": "static-1.39",
      "testing-library": "static-1.146",
      "i18n-data": "static-1.215",
      "moment-timezone": "static-5.77",
      "jasmine": "static-4.4043",
      "history": "static-4.47",
      "signup-ui-url-generator": "static-2.7743",
      "HubStyle": "static-2.11443",
      "quartz-i18n": "static-1.270",
      "sassPrefix": "static-1.150",
      "bend-plugin-foundations-components": "static-1.3605",
      "floating-ui": "static-1.50",
      "foundations-theming-specialty": "static-1.1831",
      "hs-story-utils": "static-1.9138",
      "react-virtualized": "static-2.93",
      "tanstack-table": "static-1.49",
      "trellis-assets": "static-1.996",
      "ui-fonts": "static-1.397",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3648",
      "usage-tracker-anonymous": "static-1.5464",
      "bender-build-tools": "static-1.2823",
      "dispatcher": "static-1.130",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.774",
      "hubspotter-http": "static-1.4397",
      "mobile-manifest-mixins": "static-1.466",
      "quartz-auth": "static-1.270",
      "quartz-head": "static-1.260",
      "quartz-test": "static-1.270",
      "usage-tracker-container": "static-1.7037",
      "bend-plugin-foundations-theming": "static-1.2598",
      "foundations-theming-base": "static-1.3100",
      "stylex": "static-1.26",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4360",
      "apollo-stack-hubspot": "static-3.80",
      "customer-data-ui-utilities": "static-1.9537",
      "FileManagerCore": "static-1.38141",
      "FileManagerLib": "static-1.38282",
      "graphql": "static-1.76",
      "hubspot-apollo-client": "static-1.4591",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.519",
      "timezone-utils": "static-2.4955",
      "ui-gdpr-components": "static-1.10056",
      "ts-schema": "static-1.3823",
      "avatar-components": "static-1.2177",
      "content-assistance-lib": "static-1.7320",
      "crm-component-utils": "static-1.38263",
      "crm-display-components": "static-1.24013",
      "crm-fe-perf": "static-1.22595",
      "crm-links": "static-1.5963",
      "crm-message-bus": "static-1.42136",
      "crm-search-service-types": "static-1.879",
      "crm-source-interpretation-lib": "static-1.5042",
      "customer-data-communicator": "static-1.44664",
      "customer-data-filters-ui": "static-1.38567",
      "customer-data-objects-ui-components": "static-1.12713",
      "customer-data-properties": "static-1.50521",
      "customer-data-rte": "static-1.32249",
      "draft-plugins": "static-2.21149",
      "file-manager-components": "static-1.22642",
      "framework-data-schema-resolvers": "static-1.6581",
      "frontend-preferences-client": "static-1.7635",
      "hubspot-prosemirror": "static-1.17374",
      "object-comments-thread-lib": "static-1.9882",
      "reference-resolvers-lite": "static-1.7801",
      "ui-addon-upgrades": "static-9.17432",
      "universal-associations-select": "static-1.10678",
      "ai-components-ui-library": "static-1.8121",
      "final-form": "static-1.64",
      "inbound-db-properties-service-client": "static-1.3598",
      "property-translator": "static-1.5125",
      "fast-json-stable-stringify": "static-1.4",
      "hub-http-shared-msw-handlers": "static-1.9239",
      "hubspotter-http-shared-msw-handlers": "static-1.9237",
      "react-dnd-compat": "static-1.4335",
      "audio-components": "static-1.5483",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35793",
      "immerable": "static-1.3867",
      "ui-universal-auth": "static-1.8576",
      "video-components": "static-1.12296",
      "video-data-lib": "static-1.33951",
      "video-embed": "static-1.34785",
      "hubspot-apollo-cache": "static-1.50",
      "superstore": "static-1.4484",
      "ui-addon-video-player": "static-1.8432",
      "ui-coaching-tips": "static-1.27704",
      "card-properties-lib": "static-1.43282",
      "crm-actions": "static-1.5984",
      "crm-cards-data": "static-1.1087",
      "crm-cards-sdk": "static-1.42662",
      "customer-data-properties-shared-msw-handlers": "static-1.8566",
      "customer-data-property-utils": "static-1.7781",
      "customer-data-tracking": "static-1.6573",
      "inbound-db-meta-service-client": "static-1.3379",
      "framework-data-table": "static-2.11215",
      "location-customization-utils-lib": "static-1.8277",
      "calling-error-reporting": "static-1.31006",
      "calling-internal-common": "static-1.31000",
      "calling-usage-tracker": "static-1.6250",
      "crm_data": "static-4.90952",
      "crm_schema": "static-3.90919",
      "customer-data-content": "static-1.26688",
      "draft-content-plugins": "static-1.27519",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23506",
      "draft-extend": "static-3.69",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.23318",
      "EmailSignatureEditor": "static-1.23770",
      "hubspot-prosemirror-plugins": "static-1.17366",
      "integration-settings-components": "static-1.14523",
      "integrations-lib": "static-1.15133",
      "integrations-tracking-lib": "static-1.5295",
      "native-integrations-shared-strings": "static-1.7500",
      "nav-meta": "static-1.28654",
      "onboarding-scopes": "static-1.6154",
      "outreach-assistant-email-generation": "static-1.5607",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36882",
      "react-colorpicker": "static-2.9924",
      "reference-resolvers": "static-1.7873",
      "rich-text-lib": "static-1.19311",
      "sales-email-signature-service-client": "static-1.3553",
      "sequences-lib": "static-1.7555",
      "ui-addon-i18n": "static-1.10840",
      "ui-addon-iframeable": "static-1.8730",
      "ui-business-units-lib": "static-1.8732",
      "ui-shepherd-react": "static-3.9855",
      "user-context": "static-1.4805",
      "whatsapp-sending-lib": "static-1.4688",
      "customer-data-filters-ui-msw-helpers": "static-1.21001",
      "customer-data-reference-ui-components": "static-1.12849",
      "FormUrlGenerator": "static-2.4442",
      "framework-builder-read-service-client": "static-1.3766",
      "framework-data-schema-quick-fetch": "static-1.6486",
      "multi-account-reference-resolvers": "static-1.678",
      "onboarding-tours": "static-1.16149",
      "reporting-datasets-permissions-lib": "static-1.12754",
      "SharedI18nStrings": "static-1.179",
      "ui-addon-teams": "static-1.21103",
      "calling-global-api": "static-1.63374",
      "calling-lifecycle-internal": "static-1.64756",
      "calling-lifecycle-messages": "static-1.57050",
      "commerce-products-lib": "static-1.8584",
      "conditional-properties-service-client": "static-1.3542",
      "external-options-client-types": "static-1.3902",
      "google-libphonenumber": "static-1.32",
      "hs-entities": "static-1.368",
      "inbounddb-objects-service-types": "static-1.3969",
      "meetings-icalendar-utils-lib": "static-1.345",
      "multi-currency-client-types": "static-1.3440",
      "object-builder-ui-client": "static-1.47691",
      "pipeline-validation-client-types": "static-1.3706",
      "property-value-citations": "static-1.1135",
      "pulse": "static-1.206",
      "smart-property-lib": "static-1.5579",
      "tiered-pricing": "static-1.683",
      "ui-addon-form-validation": "static-1.10707",
      "video-components-external": "static-1.10293",
      "batch-promise": "static-1.1241",
      "crm-pipelines-api-client-types": "static-1.3884",
      "persist-promise": "static-1.3398",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24483",
      "knowledge-content-types": "static-1.8277",
      "payment-link-components": "static-1.22683",
      "ui-addon-emoji-picker": "static-1.9601",
      "call-summary": "static-1.38065",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9385",
      "laboratory-lib": "static-3.6855",
      "merchandise-lib": "static-1.255",
      "purchase-motions-components": "static-1.5345",
      "self-service-api": "static-1.9937",
      "upgrade-management-service-types": "static-1.4219",
      "chatspot-core": "static-1.20010",
      "chirp-fetch": "static-1.1593",
      "ContentUtils": "static-1.67360",
      "copilot-toolkit": "static-1.10314",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "content-icons-ui": "static-1.2123",
      "social-insights-client-types": "static-1.21128",
      "outpost": "static-1.3923",
      "growth-onboarding-feedback-components": "static-1.6297",
      "customer-data-sidebar": "static-2.45193",
      "enrichment-properties-lib": "static-1.14697",
      "customer-data-associations": "static-1.7046",
      "deal-intel-decorators": "static-1.965",
      "reporting-data": "static-1.66150",
      "tanstack-virtual": "static-1.24",
      "ui-addon-draggable": "static-3.4456",
      "crm-record-cards-service-types": "static-1.3371",
      "crm_universal": "static-1.21522",
      "SalesContentIndexUI": "static-3.8758",
      "signup-ui-lego-core": "static-1.20236",
      "content-embed-lib": "static-1.7052",
      "data-model-builder-lib": "static-1.11395",
      "remote-ui": "static-1.59",
      "ui-components-test-utils": "static-1.5273",
      "ui-extensions-remote-renderer": "static-1.16191",
      "universal-page-editor-lib": "static-1.2708",
      "cohere-reconnect-lib": "static-1.78",
      "gemini-reconnect-lib": "static-1.37",
      "integrations-error-boundary-lib": "static-1.12548",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10084",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.45135",
      "data-token-picker": "static-1.15908",
      "sequences-client-types-lib": "static-1.7412",
      "foundations-components-test-utils": "static-1.4819",
      "magpie-lib": "static-1.5287",
      "navigation-messaging": "static-1.6344",
      "getting-started-shared-tasks": "static-1.17630",
      "getting-started-shared-tasks-store": "static-1.16748",
      "onboarding-tours-utils": "static-1.215",
      "messaging-usage-based-billing-components-lib": "static-1.260",
      "whatsapp-management-lib": "static-1.7847",
      "growth-data-modal": "static-1.5043",
      "growth-onboarding-confetti": "static-1.2762",
      "growth-onboarding-next-action-utils": "static-1.1206",
      "navigation-components": "static-1.17017",
      "onboarding-tours-client": "static-1.4363",
      "ui-shepherd-tracker": "static-1.7236",
      "shared-worker-versioning": "static-1.10728",
      "calling-orchestration-shared-library": "static-1.34538",
      "products-iframe-lib": "static-1.7104",
      "products-ui-components-shared-msw-handlers": "static-1.9621",
      "directed-graph": "static-1.649",
      "event-emitter": "static-1.636",
      "breeze-intelligence-kit": "static-1.5188",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9322",
      "fsm": "static-1.3442",
      "policy-lib": "static-1.6513",
      "react-tinymce": "static-1.54388",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53514",
      "tinymce-plugins": "static-1.56628",
      "tinymce-themes": "static-1.55484",
      "content-media-composition-data-lib": "static-1.11095",
      "content-media-compositions": "static-2.15102",
      "idb-keyval": "static-1.38",
      "magpie-types": "static-1.4747",
      "media-bridge-lib": "static-1.18428",
      "commerce-analytics-service-client": "static-1.3400",
      "ui-addon-opt": "static-4.8100",
      "commerce-tours-lib": "static-1.5576",
      "growth-onboarding-reliability": "static-1.4799",
      "sales-checkout-service-client": "static-1.3412",
      "ai-addon-copilot-preview": "static-1.7333",
      "calling-cross-tab-library": "static-1.18972",
      "calling-lifecycle-usage-tracker": "static-1.7928",
      "wootric-nps": "static-1.6677",
      "growth-monetization-service-types": "static-1.4235",
      "nav-client-types": "static-1.2044",
      "purchase-motions-api": "static-1.5348",
      "trials-service-types": "static-1.3636",
      "chatspot-client-types": "static-1.10364",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4519",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2762",
      "card-payment-highlight-lib": "static-1.36279",
      "card-subscription-highlight-lib": "static-1.38687",
      "commerce-billing-lib": "static-1.18236",
      "commerce-contract-lib": "static-1.10844",
      "crm_components": "static-3.90952",
      "invoices-highlight-card-lib": "static-1.53729",
      "orders-highlight-card-lib": "static-1.20665",
      "products-highlight-card-lib": "static-1.16868",
      "project-storage": "static-1.4444",
      "quotes-highlight-card-lib": "static-1.70795",
      "usage-based-billing-components-lib": "static-1.7788",
      "deal-intel-utils": "static-1.969",
      "reporting-client-types": "static-1.2355",
      "react-flip-move": "static-1.64",
      "FireAlarmUi": "static-1.4246",
      "sales-templates-service-types-lib": "static-1.3912",
      "ui-asset-management-lib": "static-1.10574",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.9381",
      "collaboration-sidebar": "static-1.56889",
      "conditional-property-settings-modal": "static-1.11751",
      "data-model-commons-lib": "static-1.11716",
      "feedback-loader": "static-1.28697",
      "html-to-image": "static-1.48",
      "object-definition-builder-lib": "static-1.6768",
      "property-management-iframe": "static-1.11985",
      "property-usages-lib": "static-1.5101",
      "reactflow": "static-1.58",
      "simple-data-table": "static-1.1957",
      "used-in-list-lib": "static-1.6623",
      "visual-association": "static-1.5553",
      "highcharts": "static-8.98",
      "reporting-visualizations": "static-1.58226",
      "ui-extensibility-client-types": "static-1.3664",
      "automation-platform-service-types": "static-1.2455",
      "ContentData": "static-1.67435",
      "email-portal-health-service-types": "static-1.687",
      "marketing-email-service-types": "static-1.1744",
      "reactive-lib": "static-1.437",
      "content-whatsapp-service-types": "static-1.222",
      "marketing-platform-lib": "static-1.6543",
      "short-messages-app-service-client": "static-1.3725",
      "ui-tool-access": "static-1.9853",
      "calling-orchestration-schema": "static-1.34763",
      "sales-views-client-types": "static-1.4004",
      "trellis-story-utils": "static-1.4234",
      "storybook-react": "static-1.27",
      "hub-http-contrib": "static-1.2757",
      "interframe": "static-3.4504",
      "tinymce-data": "static-1.39599",
      "ui-addon-sales-email": "static-1.4925",
      "codemirror": "static-5.89",
      "layout-dnd-components": "static-1.11879",
      "layout-dnd-utils": "static-1.10854",
      "react-codemirror": "static-1.10316",
      "ui-brand-identity-lib": "static-1.13462",
      "NamespacedHubStyle": "static-2.8818",
      "hls.js": "static-1.33",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.9066",
      "ai-settings-ui-library": "static-1.7241",
      "copilot-plugins": "static-1.10287",
      "eligibility-engine-service-types": "static-1.2917",
      "commerce-shared-components-lib": "static-1.17692",
      "commerce-subscription-lib": "static-1.36264",
      "commerce-tools-ui-lib": "static-1.9583",
      "usage-tracker-session-replay": "static-1.4733",
      "utility-belt": "static-1.2253",
      "payments-enrollment-embed-lib": "static-1.21638",
      "quotes-ui-lib": "static-1.79513",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6565",
      "invoices-ui-lib": "static-1.53745",
      "commerce-products-api": "static-1.1814",
      "SafeStorage": "static-1.4115",
      "invoices-iframe-lib": "static-1.55803",
      "quotes-modal-lib": "static-1.101470",
      "platform-infra-nav-components": "static-1.7411",
      "reporting-ui-components": "static-2.63422",
      "subscription-experience-data-types": "static-1.14474",
      "association-translator": "static-1.2904",
      "crm-settings-header-lib": "static-1.8017",
      "settings-ui-nav": "static-2.9862",
      "chatspot-widget-iframe": "static-1.20002",
      "collaboration-sidebar-common": "static-1.1686",
      "crm-properties-common-lib": "static-1.5581",
      "ui-addon-draggable-compat": "static-2.3965",
      "property-management-common": "static-1.4272",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14670",
      "advanced-menus-lib": "static-1.11661",
      "ExportDialog": "static-6.10099",
      "ui-memberships-settings-lib": "static-1.33190",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9179",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13261",
      "highlight.js": "static-1.73",
      "reporting-action-components": "static-1.40459",
      "reporting-snowflake": "static-1.54768",
      "ui-addon-react-router-dom": "static-1.9258",
      "growth-onboarding-empty-states": "static-1.5237",
      "InboxConnectUtils": "static-4.13997",
      "payments-post-enroll-local-storage-lib": "static-1.4800",
      "qrcode-generator": "static-1.63",
      "amplitude-session-replay-browser": "static-1.54",
      "marketplace-ui-apps-core": "static-1.17269",
      "stripe-embedded-components": "static-1.6982",
      "products-ui-components": "static-1.39103",
      "totals-ui-components": "static-1.22759",
      "reporting-plugins": "static-1.9872",
      "reporting-reports": "static-1.65828",
      "edison-service-client-types": "static-1.102",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14669",
      "simple-menus-lib": "static-1.16186",
      "academy-common-lib": "static-1.12721",
      "dashboard-lib": "static-1.80273",
      "share-with-third-party-component-lib": "static-1.8401",
      "developer-experience-shared-components": "static-1.10167",
      "marketplace-ui-client-types": "static-1.16143",
      "marketplace-ui-common": "static-1.18736",
      "ui-addon-integrations-directory-panel": "static-2.7693",
      "stripe-connect-js": "static-1.62",
      "commerce-permissions": "static-1.463",
      "property-description-translator": "static-1.3571",
      "commerce-totals-service-types": "static-1.3559",
      "campaign-roi-lib": "static-1.8020",
      "academy-service-client": "static-1.3369",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3591",
      "oauth-service-types": "static-1.3952",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28081",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4420",
      "atom": "/atom/static-1.4783",
      "conversations-async-data": "/conversations-async-data/static-2.7373",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8588",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15674",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12340",
      "conversations-message-history": "/conversations-message-history/static-1.11774",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10209",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21444",
      "head-dlb": "/head-dlb/static-1.4754",
      "hs-promise-utils": "/hs-promise-utils/static-1.5302",
      "hs-test-utils": "/hs-test-utils/static-1.7694",
      "hubspot-dlb": "/hubspot-dlb/static-2.1786",
      "HubStyleTokens": "/HubStyleTokens/static-2.11135",
      "I18n": "/I18n/static-7.1545",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2729",
      "jasmine-runner": "/jasmine-runner/static-1.6166",
      "quartz": "/quartz/static-1.6595",
      "react-dlb": "/react-dlb/static-1.70",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.59",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4186",
      "StyleGuideUI": "/StyleGuideUI/static-3.482",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4246",
      "usage-tracker": "/usage-tracker/static-1.7047",
      "usage-tracker-core": "/usage-tracker-core/static-1.6897",
      "usage-tracker-public": "/usage-tracker-public/static-1.6858",
      "viral-links-lib": "/viral-links-lib/static-1.6731",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5839",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4497",
      "conversations-prop-types": "/conversations-prop-types/static-1.7162",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.20181",
      "cssUtils": "/cssUtils/static-1.704",
      "enviro": "/enviro/static-4.387",
      "flux-actions": "/flux-actions/static-1.298",
      "foundations-components": "/foundations-components/static-1.7336",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5872",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9346",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.349",
      "raven": "/raven/static-3.5624",
      "react": "/react/static-7.176",
      "react-aria": "/react-aria/static-1.60",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.66",
      "react-rhumb": "/react-rhumb/static-1.16344",
      "react-utils": "/react-utils/static-2.5095",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7851",
      "signup-constants": "/signup-constants/static-1.18226",
      "styled-components": "/styled-components/static-2.84",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5461",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5650",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
      "raven-hubspot": "/raven-hubspot/static-1.5931",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3148",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.373",
      "quartz-core": "/quartz-core/static-1.5814",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4543",
      "foundations-theming": "/foundations-theming/static-1.4115",
      "UIComponents": "/UIComponents/static-3.8082",
      "customer-data-email": "/customer-data-email/static-1.17526",
      "cv-backend-services": "/cv-backend-services/static-1.1466",
      "immutable-less": "/immutable-less/static-1.4366",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6962",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.32159",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2222",
      "customer-data-objects": "/customer-data-objects/static-1.7324",
      "data-fetching-client": "/data-fetching-client/static-1.9387",
      "icons": "/icons/static-2.614",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-router-dom": "/react-router-dom/static-5.26",
      "rpc-client-utils": "/rpc-client-utils/static-1.4318",
      "ui-images": "/ui-images/static-2.1065",
      "HeadJS": "/HeadJS/static-2.693",
      "framer-motion": "/framer-motion/static-1.66",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2805",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.146",
      "i18n-data": "/i18n-data/static-1.215",
      "moment-timezone": "/moment-timezone/static-5.77",
      "jasmine": "/jasmine/static-4.4043",
      "history": "/history/static-4.47",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7743",
      "HubStyle": "/HubStyle/static-2.11443",
      "quartz-i18n": "/quartz-i18n/static-1.270",
      "sassPrefix": "/sassPrefix/static-1.150",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3605",
      "floating-ui": "/floating-ui/static-1.50",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1831",
      "hs-story-utils": "/hs-story-utils/static-1.9138",
      "react-virtualized": "/react-virtualized/static-2.93",
      "tanstack-table": "/tanstack-table/static-1.49",
      "trellis-assets": "/trellis-assets/static-1.996",
      "ui-fonts": "/ui-fonts/static-1.397",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3648",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5464",
      "bender-build-tools": "/bender-build-tools/static-1.2823",
      "dispatcher": "/dispatcher/static-1.130",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.774",
      "hubspotter-http": "/hubspotter-http/static-1.4397",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.466",
      "quartz-auth": "/quartz-auth/static-1.270",
      "quartz-head": "/quartz-head/static-1.260",
      "quartz-test": "/quartz-test/static-1.270",
      "usage-tracker-container": "/usage-tracker-container/static-1.7037",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2598",
      "foundations-theming-base": "/foundations-theming-base/static-1.3100",
      "stylex": "/stylex/static-1.26",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4360",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9537",
      "FileManagerCore": "/FileManagerCore/static-1.38141",
      "FileManagerLib": "/FileManagerLib/static-1.38282",
      "graphql": "/graphql/static-1.76",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4591",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.519",
      "timezone-utils": "/timezone-utils/static-2.4955",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10056",
      "ts-schema": "/ts-schema/static-1.3823",
      "avatar-components": "/avatar-components/static-1.2177",
      "content-assistance-lib": "/content-assistance-lib/static-1.7320",
      "crm-component-utils": "/crm-component-utils/static-1.38263",
      "crm-display-components": "/crm-display-components/static-1.24013",
      "crm-fe-perf": "/crm-fe-perf/static-1.22595",
      "crm-links": "/crm-links/static-1.5963",
      "crm-message-bus": "/crm-message-bus/static-1.42136",
      "crm-search-service-types": "/crm-search-service-types/static-1.879",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5042",
      "customer-data-communicator": "/customer-data-communicator/static-1.44664",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38567",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12713",
      "customer-data-properties": "/customer-data-properties/static-1.50521",
      "customer-data-rte": "/customer-data-rte/static-1.32249",
      "draft-plugins": "/draft-plugins/static-2.21149",
      "file-manager-components": "/file-manager-components/static-1.22642",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6581",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7635",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17374",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9882",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7801",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17432",
      "universal-associations-select": "/universal-associations-select/static-1.10678",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8121",
      "final-form": "/final-form/static-1.64",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3598",
      "property-translator": "/property-translator/static-1.5125",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9239",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9237",
      "react-dnd-compat": "/react-dnd-compat/static-1.4335",
      "audio-components": "/audio-components/static-1.5483",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35793",
      "immerable": "/immerable/static-1.3867",
      "ui-universal-auth": "/ui-universal-auth/static-1.8576",
      "video-components": "/video-components/static-1.12296",
      "video-data-lib": "/video-data-lib/static-1.33951",
      "video-embed": "/video-embed/static-1.34785",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.50",
      "superstore": "/superstore/static-1.4484",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27704",
      "card-properties-lib": "/card-properties-lib/static-1.43282",
      "crm-actions": "/crm-actions/static-1.5984",
      "crm-cards-data": "/crm-cards-data/static-1.1087",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42662",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8566",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7781",
      "customer-data-tracking": "/customer-data-tracking/static-1.6573",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3379",
      "framework-data-table": "/framework-data-table/static-2.11215",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8277",
      "calling-error-reporting": "/calling-error-reporting/static-1.31006",
      "calling-internal-common": "/calling-internal-common/static-1.31000",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6250",
      "crm_data": "/crm_data/static-4.90952",
      "crm_schema": "/crm_schema/static-3.90919",
      "customer-data-content": "/customer-data-content/static-1.26688",
      "draft-content-plugins": "/draft-content-plugins/static-1.27519",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23506",
      "draft-extend": "/draft-extend/static-3.69",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23318",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23770",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17366",
      "integration-settings-components": "/integration-settings-components/static-1.14523",
      "integrations-lib": "/integrations-lib/static-1.15133",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5295",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7500",
      "nav-meta": "/nav-meta/static-1.28654",
      "onboarding-scopes": "/onboarding-scopes/static-1.6154",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5607",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36882",
      "react-colorpicker": "/react-colorpicker/static-2.9924",
      "reference-resolvers": "/reference-resolvers/static-1.7873",
      "rich-text-lib": "/rich-text-lib/static-1.19311",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3553",
      "sequences-lib": "/sequences-lib/static-1.7555",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10840",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8730",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8732",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9855",
      "user-context": "/user-context/static-1.4805",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4688",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21001",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12849",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4442",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3766",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6486",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.678",
      "onboarding-tours": "/onboarding-tours/static-1.16149",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12754",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
      "ui-addon-teams": "/ui-addon-teams/static-1.21103",
      "calling-global-api": "/calling-global-api/static-1.63374",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64756",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57050",
      "commerce-products-lib": "/commerce-products-lib/static-1.8584",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3542",
      "external-options-client-types": "/external-options-client-types/static-1.3902",
      "google-libphonenumber": "/google-libphonenumber/static-1.32",
      "hs-entities": "/hs-entities/static-1.368",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3969",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.345",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3440",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47691",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3706",
      "property-value-citations": "/property-value-citations/static-1.1135",
      "pulse": "/pulse/static-1.206",
      "smart-property-lib": "/smart-property-lib/static-1.5579",
      "tiered-pricing": "/tiered-pricing/static-1.683",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10707",
      "video-components-external": "/video-components-external/static-1.10293",
      "batch-promise": "/batch-promise/static-1.1241",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3884",
      "persist-promise": "/persist-promise/static-1.3398",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24483",
      "knowledge-content-types": "/knowledge-content-types/static-1.8277",
      "payment-link-components": "/payment-link-components/static-1.22683",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9601",
      "call-summary": "/call-summary/static-1.38065",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9385",
      "laboratory-lib": "/laboratory-lib/static-3.6855",
      "merchandise-lib": "/merchandise-lib/static-1.255",
      "purchase-motions-components": "/purchase-motions-components/static-1.5345",
      "self-service-api": "/self-service-api/static-1.9937",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4219",
      "chatspot-core": "/chatspot-core/static-1.20010",
      "chirp-fetch": "/chirp-fetch/static-1.1593",
      "ContentUtils": "/ContentUtils/static-1.67360",
      "copilot-toolkit": "/copilot-toolkit/static-1.10314",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "content-icons-ui": "/content-icons-ui/static-1.2123",
      "social-insights-client-types": "/social-insights-client-types/static-1.21128",
      "outpost": "/outpost/static-1.3923",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6297",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45193",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14697",
      "customer-data-associations": "/customer-data-associations/static-1.7046",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.965",
      "reporting-data": "/reporting-data/static-1.66150",
      "tanstack-virtual": "/tanstack-virtual/static-1.24",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4456",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3371",
      "crm_universal": "/crm_universal/static-1.21522",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8758",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20236",
      "content-embed-lib": "/content-embed-lib/static-1.7052",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11395",
      "remote-ui": "/remote-ui/static-1.59",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5273",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16191",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2708",
      "cohere-reconnect-lib": "/cohere-reconnect-lib/static-1.78",
      "gemini-reconnect-lib": "/gemini-reconnect-lib/static-1.37",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12548",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10084",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.45135",
      "data-token-picker": "/data-token-picker/static-1.15908",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7412",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4819",
      "magpie-lib": "/magpie-lib/static-1.5287",
      "navigation-messaging": "/navigation-messaging/static-1.6344",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17630",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16748",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.215",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.260",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7847",
      "growth-data-modal": "/growth-data-modal/static-1.5043",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2762",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1206",
      "navigation-components": "/navigation-components/static-1.17017",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4363",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7236",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10728",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34538",
      "products-iframe-lib": "/products-iframe-lib/static-1.7104",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9621",
      "directed-graph": "/directed-graph/static-1.649",
      "event-emitter": "/event-emitter/static-1.636",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5188",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9322",
      "fsm": "/fsm/static-1.3442",
      "policy-lib": "/policy-lib/static-1.6513",
      "react-tinymce": "/react-tinymce/static-1.54388",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53514",
      "tinymce-plugins": "/tinymce-plugins/static-1.56628",
      "tinymce-themes": "/tinymce-themes/static-1.55484",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11095",
      "content-media-compositions": "/content-media-compositions/static-2.15102",
      "idb-keyval": "/idb-keyval/static-1.38",
      "magpie-types": "/magpie-types/static-1.4747",
      "media-bridge-lib": "/media-bridge-lib/static-1.18428",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3400",
      "ui-addon-opt": "/ui-addon-opt/static-4.8100",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5576",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4799",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3412",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7333",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18972",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.7928",
      "wootric-nps": "/wootric-nps/static-1.6677",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4235",
      "nav-client-types": "/nav-client-types/static-1.2044",
      "purchase-motions-api": "/purchase-motions-api/static-1.5348",
      "trials-service-types": "/trials-service-types/static-1.3636",
      "chatspot-client-types": "/chatspot-client-types/static-1.10364",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4519",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2762",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36279",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38687",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18236",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10844",
      "crm_components": "/crm_components/static-3.90952",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53729",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20665",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16868",
      "project-storage": "/project-storage/static-1.4444",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70795",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7788",
      "deal-intel-utils": "/deal-intel-utils/static-1.969",
      "reporting-client-types": "/reporting-client-types/static-1.2355",
      "react-flip-move": "/react-flip-move/static-1.64",
      "FireAlarmUi": "/FireAlarmUi/static-1.4246",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3912",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10574",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.9381",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56889",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.11751",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11716",
      "feedback-loader": "/feedback-loader/static-1.28697",
      "html-to-image": "/html-to-image/static-1.48",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6768",
      "property-management-iframe": "/property-management-iframe/static-1.11985",
      "property-usages-lib": "/property-usages-lib/static-1.5101",
      "reactflow": "/reactflow/static-1.58",
      "simple-data-table": "/simple-data-table/static-1.1957",
      "used-in-list-lib": "/used-in-list-lib/static-1.6623",
      "visual-association": "/visual-association/static-1.5553",
      "highcharts": "/highcharts/static-8.98",
      "reporting-visualizations": "/reporting-visualizations/static-1.58226",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3664",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2455",
      "ContentData": "/ContentData/static-1.67435",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.687",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1744",
      "reactive-lib": "/reactive-lib/static-1.437",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.222",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6543",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3725",
      "ui-tool-access": "/ui-tool-access/static-1.9853",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34763",
      "sales-views-client-types": "/sales-views-client-types/static-1.4004",
      "trellis-story-utils": "/trellis-story-utils/static-1.4234",
      "storybook-react": "/storybook-react/static-1.27",
      "hub-http-contrib": "/hub-http-contrib/static-1.2757",
      "interframe": "/interframe/static-3.4504",
      "tinymce-data": "/tinymce-data/static-1.39599",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4925",
      "codemirror": "/codemirror/static-5.89",
      "layout-dnd-components": "/layout-dnd-components/static-1.11879",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10854",
      "react-codemirror": "/react-codemirror/static-1.10316",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13462",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8818",
      "hls.js": "/hls.js/static-1.33",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.9066",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7241",
      "copilot-plugins": "/copilot-plugins/static-1.10287",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2917",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17692",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36264",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9583",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4733",
      "utility-belt": "/utility-belt/static-1.2253",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21638",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79513",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6565",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53745",
      "commerce-products-api": "/commerce-products-api/static-1.1814",
      "SafeStorage": "/SafeStorage/static-1.4115",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55803",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101470",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7411",
      "reporting-ui-components": "/reporting-ui-components/static-2.63422",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14474",
      "association-translator": "/association-translator/static-1.2904",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.8017",
      "settings-ui-nav": "/settings-ui-nav/static-2.9862",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20002",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1686",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5581",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3965",
      "property-management-common": "/property-management-common/static-1.4272",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14670",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11661",
      "ExportDialog": "/ExportDialog/static-6.10099",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33190",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9179",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13261",
      "highlight.js": "/highlight.js/static-1.73",
      "reporting-action-components": "/reporting-action-components/static-1.40459",
      "reporting-snowflake": "/reporting-snowflake/static-1.54768",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9258",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5237",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13997",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4800",
      "qrcode-generator": "/qrcode-generator/static-1.63",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17269",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6982",
      "products-ui-components": "/products-ui-components/static-1.39103",
      "totals-ui-components": "/totals-ui-components/static-1.22759",
      "reporting-plugins": "/reporting-plugins/static-1.9872",
      "reporting-reports": "/reporting-reports/static-1.65828",
      "edison-service-client-types": "/edison-service-client-types/static-1.102",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14669",
      "simple-menus-lib": "/simple-menus-lib/static-1.16186",
      "academy-common-lib": "/academy-common-lib/static-1.12721",
      "dashboard-lib": "/dashboard-lib/static-1.80273",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8401",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10167",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16143",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18736",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7693",
      "stripe-connect-js": "/stripe-connect-js/static-1.62",
      "commerce-permissions": "/commerce-permissions/static-1.463",
      "property-description-translator": "/property-description-translator/static-1.3571",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3559",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8020",
      "academy-service-client": "/academy-service-client/static-1.3369",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3591",
      "oauth-service-types": "/oauth-service-types/static-1.3952",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};